import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";

/* eslint indent: ["off"] */
import $ from 'dom7';
import { window, document } from 'ssr-window';
import Utils from '../../utils/utils';
import Modal from '../modal/modal-class';

var Actions =
/*#__PURE__*/
function (_Modal) {
  _inherits(Actions, _Modal);

  function Actions(app, params) {
    var _this;

    _classCallCheck(this, Actions);

    var extendedParams = Utils.extend({
      on: {}
    }, app.params.actions, params); // Extends with open/close Modal methods;

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Actions).call(this, app, extendedParams));

    var actions = _assertThisInitialized(_assertThisInitialized(_this));

    actions.params = extendedParams; // Buttons

    var groups;

    if (actions.params.buttons) {
      groups = actions.params.buttons;
      if (!Array.isArray(groups[0])) groups = [groups];
    }

    actions.groups = groups; // Find Element

    var $el;

    if (actions.params.el) {
      $el = $(actions.params.el).eq(0);
    } else if (actions.params.content) {
      $el = $(actions.params.content).filter(function (elIndex, node) {
        return node.nodeType === 1;
      }).eq(0);
    } else if (actions.params.buttons) {
      if (actions.params.convertToPopover) {
        actions.popoverHtml = actions.renderPopover();
      }

      actions.actionsHtml = actions.render();
    }

    if ($el && $el.length > 0 && $el[0].f7Modal) {
      return _possibleConstructorReturn(_this, $el[0].f7Modal);
    }

    if ($el && $el.length === 0 && !(actions.actionsHtml || actions.popoverHtml)) {
      return _possibleConstructorReturn(_this, actions.destroy());
    } // Backdrop


    var $backdropEl;

    if (actions.params.backdrop && actions.params.backdropEl) {
      $backdropEl = $(actions.params.backdropEl);
    } else if (actions.params.backdrop) {
      $backdropEl = app.root.children('.actions-backdrop');

      if ($backdropEl.length === 0) {
        $backdropEl = $('<div class="actions-backdrop"></div>');
        app.root.append($backdropEl);
      }
    }

    var originalOpen = actions.open;
    var originalClose = actions.close;
    var popover;

    function buttonOnClick(e) {
      var $buttonEl = $(this);
      var buttonIndex;
      var groupIndex;

      if ($buttonEl.hasClass('list-button') || $buttonEl.hasClass('item-link')) {
        buttonIndex = $buttonEl.parents('li').index();
        groupIndex = $buttonEl.parents('.list').index();
      } else {
        buttonIndex = $buttonEl.index();
        groupIndex = $buttonEl.parents('.actions-group').index();
      }

      if (typeof groups !== 'undefined') {
        var button = groups[groupIndex][buttonIndex];
        if (button.onClick) button.onClick(actions, e);
        if (actions.params.onClick) actions.params.onClick(actions, e);
        if (button.close !== false) actions.close();
      }
    }

    actions.open = function open(animate) {
      var convertToPopover = false;
      var _actions$params = actions.params,
          targetEl = _actions$params.targetEl,
          targetX = _actions$params.targetX,
          targetY = _actions$params.targetY,
          targetWidth = _actions$params.targetWidth,
          targetHeight = _actions$params.targetHeight;

      if (actions.params.convertToPopover && (targetEl || targetX !== undefined && targetY !== undefined)) {
        // Popover
        if (actions.params.forceToPopover || app.device.ios && app.device.ipad || app.width >= 768 || app.device.desktop && app.theme === 'aurora') {
          convertToPopover = true;
        }
      }

      if (convertToPopover && actions.popoverHtml) {
        popover = app.popover.create({
          content: actions.popoverHtml,
          backdrop: actions.params.backdrop,
          targetEl: targetEl,
          targetX: targetX,
          targetY: targetY,
          targetWidth: targetWidth,
          targetHeight: targetHeight
        });
        popover.open(animate);
        popover.once('popoverOpened', function () {
          popover.$el.find('.list-button, .item-link').each(function (groupIndex, buttonEl) {
            $(buttonEl).on('click', buttonOnClick);
          });
        });
        popover.once('popoverClosed', function () {
          popover.$el.find('.list-button, .item-link').each(function (groupIndex, buttonEl) {
            $(buttonEl).off('click', buttonOnClick);
          });
          Utils.nextTick(function () {
            popover.destroy();
            popover = undefined;
          });
        });
      } else {
        actions.$el = actions.actionsHtml ? $(actions.actionsHtml) : actions.$el;
        actions.$el[0].f7Modal = actions;

        if (actions.groups) {
          actions.$el.find('.actions-button').each(function (groupIndex, buttonEl) {
            $(buttonEl).on('click', buttonOnClick);
          });
          actions.once('actionsClosed', function () {
            actions.$el.find('.actions-button').each(function (groupIndex, buttonEl) {
              $(buttonEl).off('click', buttonOnClick);
            });
          });
        }

        actions.el = actions.$el[0];
        originalOpen.call(actions, animate);
      }

      return actions;
    };

    actions.close = function close(animate) {
      if (popover) {
        popover.close(animate);
      } else {
        originalClose.call(actions, animate);
      }

      return actions;
    };

    Utils.extend(actions, {
      app: app,
      $el: $el,
      el: $el ? $el[0] : undefined,
      $backdropEl: $backdropEl,
      backdropEl: $backdropEl && $backdropEl[0],
      type: 'actions'
    });

    function handleClick(e) {
      var target = e.target;
      var $target = $(target);
      var keyboardOpened = !app.device.desktop && app.device.cordova && (window.Keyboard && window.Keyboard.isVisible || window.cordova.plugins && window.cordova.plugins.Keyboard && window.cordova.plugins.Keyboard.isVisible);
      if (keyboardOpened) return;

      if ($target.closest(actions.el).length === 0) {
        if (actions.params.closeByBackdropClick && actions.params.backdrop && actions.backdropEl && actions.backdropEl === target) {
          actions.close();
        } else if (actions.params.closeByOutsideClick) {
          actions.close();
        }
      }
    }

    function onKeyDown(e) {
      var keyCode = e.keyCode;

      if (keyCode === 27 && actions.params.closeOnEscape) {
        actions.close();
      }
    }

    if (actions.params.closeOnEscape) {
      actions.on('open', function () {
        $(document).on('keydown', onKeyDown);
      });
      actions.on('close', function () {
        $(document).off('keydown', onKeyDown);
      });
    }

    actions.on('opened', function () {
      if (actions.params.closeByBackdropClick || actions.params.closeByOutsideClick) {
        app.on('click', handleClick);
      }
    });
    actions.on('close', function () {
      if (actions.params.closeByBackdropClick || actions.params.closeByOutsideClick) {
        app.off('click', handleClick);
      }
    });

    if ($el) {
      $el[0].f7Modal = actions;
    }

    return _possibleConstructorReturn(_this, actions);
  }

  _createClass(Actions, [{
    key: "render",
    value: function render() {
      var actions = this;
      if (actions.params.render) return actions.params.render.call(actions, actions);
      var groups = actions.groups;
      return "\n      <div class=\"actions-modal".concat(actions.params.grid ? ' actions-grid' : '', "\">\n        ").concat(groups.map(function (group) {
        return "<div class=\"actions-group\">\n            ".concat(group.map(function (button) {
          var buttonClasses = ["actions-".concat(button.label ? 'label' : 'button')];
          var color = button.color,
              bg = button.bg,
              bold = button.bold,
              disabled = button.disabled,
              label = button.label,
              text = button.text,
              icon = button.icon;
          if (color) buttonClasses.push("color-".concat(color));
          if (bg) buttonClasses.push("bg-color-".concat(bg));
          if (bold) buttonClasses.push('actions-button-bold');
          if (disabled) buttonClasses.push('disabled');

          if (label) {
            return "<div class=\"".concat(buttonClasses.join(' '), "\">").concat(text, "</div>");
          }

          return "\n                <div class=\"".concat(buttonClasses.join(' '), "\">\n                  ").concat(icon ? "<div class=\"actions-button-media\">".concat(icon, "</div>") : '', "\n                  <div class=\"actions-button-text\">").concat(text, "</div>\n                </div>").trim();
        }).join(''), "\n          </div>");
      }).join(''), "\n      </div>\n    ").trim();
    }
  }, {
    key: "renderPopover",
    value: function renderPopover() {
      var actions = this;
      if (actions.params.renderPopover) return actions.params.renderPopover.call(actions, actions);
      var groups = actions.groups;
      return "\n      <div class=\"popover popover-from-actions\">\n        <div class=\"popover-inner\">\n          ".concat(groups.map(function (group) {
        return "\n            <div class=\"list\">\n              <ul>\n                ".concat(group.map(function (button) {
          var itemClasses = [];
          var color = button.color,
              bg = button.bg,
              bold = button.bold,
              disabled = button.disabled,
              label = button.label,
              text = button.text,
              icon = button.icon;
          if (color) itemClasses.push("color-".concat(color));
          if (bg) itemClasses.push("bg-color-".concat(bg));
          if (bold) itemClasses.push('popover-from-actions-bold');
          if (disabled) itemClasses.push('disabled');

          if (label) {
            itemClasses.push('popover-from-actions-label');
            return "<li class=\"".concat(itemClasses.join(' '), "\">").concat(text, "</li>");
          }

          if (icon) {
            itemClasses.push('item-link item-content');
            return "\n                      <li>\n                        <a class=\"".concat(itemClasses.join(' '), "\">\n                          <div class=\"item-media\">\n                            ").concat(icon, "\n                          </div>\n                          <div class=\"item-inner\">\n                            <div class=\"item-title\">\n                              ").concat(text, "\n                            </div>\n                          </div>\n                        </a>\n                      </li>\n                    ");
          }

          itemClasses.push('list-button');
          return "\n                    <li>\n                      <a class=\"".concat(itemClasses.join(' '), "\">").concat(text, "</a>\n                    </li>\n                  ");
        }).join(''), "\n              </ul>\n            </div>\n          ");
      }).join(''), "\n        </div>\n      </div>\n    ").trim();
    }
  }]);

  return Actions;
}(Modal);

export default Actions;